// t() for the product dialog, over the CMS TextBundle "store_product_editor",
// in the site's language.
//
// The code writes English — t`Pricing`, t(tab.label), t("%s pages", n) — and the English finds
// its key in ./texts-en.js: the bundle's translation when it has one, the
// English itself until it has loaded or when it has no such text (a tab an
// extension brings that the bundle does not know keeps its own label).
import { useMemo } from "react"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import TEXTS from "./texts-en"

export const BUNDLE_ID = "store_product_editor"

const byEnglish = new Map(Object.entries(TEXTS).map(([key, english]) => [english, key]))

const format = (text, args) => {
  if (!args.length) return text
  let i = 0
  return text.replace(/%s/g, () => (i < args.length ? String(args[i++]) : "%s"))
}

export default function useProductEditorTexts() {
  const loaded = TextBundle({ id: BUNDLE_ID })
  return useMemo(
    () => (text, ...args) => {
      // tagged template: t`English`
      if (Array.isArray(text)) text = text[0]
      if (text === undefined || text === null) return ""
      const key = Object.prototype.hasOwnProperty.call(TEXTS, text) ? text : byEnglish.get(text)
      const translated = key !== undefined ? loaded?.[key] : undefined
      return format(typeof translated === "string" && translated ? translated : key !== undefined ? TEXTS[key] : String(text), args)
    },
    [loaded]
  )
}
